<template>
  <div class="search-sidebar--single">
    <h3 class="filter--title">{{ $t('general.filter.priceRange') }}</h3>
    <v-select
      v-model="selectedPriceRange"
      :items="priceRanges"
      :label="$t('general.filter.priceRange')"
      item-value="id"
      item-text="name"
      solo
      hide-details
      return-object
    >
      <template v-slot:selection="{ item, index }">
        {{ item.name }}
      </template>
    </v-select>
  </div>
</template>

<script>
import SearchMixin from '@/mixins/searchMixin';
import LodashMixin from '@/mixins/lodash';
import { mapState } from 'vuex';

export default {
  mixins: [SearchMixin, LodashMixin],
  components: {},
  computed: {
    ...mapState({
      isLoading: (state) => state.searchListing.isLoading,
      priceRanges: (state) => state.searchListing.priceRanges,
    }),
    selectedPriceRange: {
      get() {
        return this.$store.state.searchListing.selectedPriceRange;
      },
      set(value) {
        this.$store.commit('searchListing/SET_SELECTED_PRICE_RANGE', value);

        // APPLY FILTER ON SELECT MIN BEDROOM
        if (this.$mq !== 'xs') {
          this.$store.dispatch('searchListing/goToSearchPage', {
            router: this.$router,
            params: this.$route.params,
          });
        }
      },
    },
  },
  data: () => ({}),
  methods: {},
};
</script>
